// extracted by mini-css-extract-plugin
export default {"container":"CmsDynamicIframe-module__container-pN3Lm_","loaded":"CmsDynamicIframe-module__loaded-AyDrQP"};